import axios from 'axios';
import { criptoLocalStorage, decriptObjectOnLocalStorage, decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import apiZelo from '../backAxiosVendaToken';
import { retornoHashValor } from '../../modulos/cripotografia/hash';

const url = retornoHashValor(process.env.REACT_APP_1);
const token = localStorage.getItem('token');
const permissao = decriptObjectOnLocalStorage('PERM');

export const api = axios.create({
    baseURL: url,
    headers: { 'x-auth-token': token }
});

export const getMenu = async () => {
    try {
        const response = await apiZelo.get(
            `/menu/${permissao}`
        );

        if (response.data.length > 0) {
            return response.data;
        } else {
            return 'parametros errados';
        }
    } catch (error) {
        return error.message;
    }
};

export const getIconeByPermissao = permissaoAtual => {
    try {
        const iconesPermissoes = [
            {
                id: '1',
                icon: 'pi pi-fw pi-user-plus'
            },
            {
                id: '2',
                icon: 'pi pi-fw pi-users'
            },
            {
                id: '3',
                icon: 'pi pi-fw pi-users'
            }
        ];

        return iconesPermissoes.find(({ id }) => id === permissaoAtual).icon;
    } catch (error) {
        return error;
    }
};

export const getMenuPerfisByPermissao = permissaoAtual => {
    try {
        let menu = '';

        if (permissaoAtual === 1) {
            const usuarioSupervisor = decriptoLocalStorage('USRSUP')?.decriptoValue ? true : false;
            const usuarioCoordenador = decriptoLocalStorage('USRCOO')?.decriptoValue ? true : false;

            let label = '';
            let proximaPermissao = '';

            if(usuarioSupervisor){
                label = 'Supervisor';
                proximaPermissao = '3';
            } else if(usuarioCoordenador){
                label = 'Coordenador';
                proximaPermissao = '2';
            }

            menu = [
                {
                    label,
                    icon: 'pi pi-fw pi-users',
                    command: () => {
                        criptoLocalStorage('PERM', proximaPermissao);

                        window.location.href = '/';
                    }
                }
            ];
        } else {
            menu = [
                {
                    label: 'Vendedor',
                    icon: 'pi pi-fw pi-user-plus',
                    command: () => {
                        criptoLocalStorage('PERM', '1');

                        window.location.href = '/';
                    }
                }
            ];
        }

        return menu;
    } catch (error) {
        return error;
    }
};

export const getMenuPerfisPossiveis = () => {
    const isPossivel = decriptoLocalStorage('perfilPossivel')?.decriptoValue === '1';
    const isVendedor = decriptoLocalStorage('area')?.decriptoValue === '1';
    const isVendedorPrime = decriptoLocalStorage('area')?.decriptoValue === '3';

    try {
        if (isPossivel && ( isVendedor || isVendedorPrime)) {
            return [
                {
                    label: 'Trocar perfil',
                    icon: 'pi pi-fw pi-sort-alt',
                    items: getMenuPerfisByPermissao(decriptObjectOnLocalStorage('PERM'))
                },
                {
                    label: 'Ajuda',
                    icon: 'pi pi-fw pi-question-circle',
                    command: () => (window.location.href = '/ajuda')
                },
                {
                    label: 'Logout',
                    icon: 'pi pi-fw pi-sign-in',
                    command: () => {
                        localStorage.removeItem('TOKEN');
                        window.location.reload();
                        localStorage.clear();
                        sessionStorage.clear();
                    }
                }
            ];
        } else {
            return [
                {
                    label: 'Ajuda',
                    icon: 'pi pi-fw pi-question-circle',
                    command: () => (window.location.href = '/ajuda')
                },
                {
                    label: 'Logout',
                    icon: 'pi pi-fw pi-sign-in',
                    command: () => {
                        localStorage.removeItem('TOKEN');
                        window.location.reload();
                        localStorage.clear();
                        sessionStorage.clear();
                    }
                }
            ];
        }
    } catch (error) {
        return error;
    }
};
